import React from "react";
import { Document, Link, Page, PDFDownloadLink, PDFViewer, Text, View, StyleSheet } from '@react-pdf/renderer';

// Create styles
const styles = StyleSheet.create({
  page: {
    padding: '15px',
    color: '#222c35'
  },
  section: {
    margin: 10,
    padding: 10,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  heading: {
    display: 'block', 
    margin: '10px 0',
    fontWeight: '800',
  },
  subtitle: {
    display: 'block',
    color: '#535a5f',
    margin: '5px 0 15px 0',
    fontSize: '15',
  },

  listItem: {
    fontSize: '16',
    margin: '5px 0',
    color: '#4b5a68',
    display: 'flex',
    justifyContent: 'space-between',
  },

  listItemLeft: {
    fontWeight: '800',
    width: '250px',
    margin: '0 55px 0 0',
    color: 'black',
    display: 'inline-block',
  },

  link: {
    color: '#535a5f',
    fontStyle: 'italic',
    fontSize: '13',
    marginTop: '35px'
  }

});

const PDFDocument = ({ companyType, revenue, employee, amountEmployee, productivity, result }) => {
  return  (
    <Document>
      <Page size="A4" style={styles.page}>
        <View style={styles.section}>
          <Text style={styles.heading}>KAN HÄLSOARBETET FÖRBÄTTRA ERT RESULTAT?</Text>
          <Text style={styles.subtitle}>Här nedan kan du beräkna hur lönsam en hälsosatsning kan bli genom att uppskatta förbättringspotentialen hos era medarbetare.</Text>
          <Text style={styles.listItem}><Text style={styles.listItemLeft}>Vår årliga omsättning: </Text>{revenue} kronor</Text>
          <Text style={styles.listItem}><Text style={styles.listItemLeft}>Antal anställda: </Text><Text>{employee} personer</Text></Text>
          <Text style={styles.listItem}><Text style={styles.listItemLeft}>Procentandel som kan förbättras: </Text>{amountEmployee}%</Text>
          <Text style={styles.listItem}><Text style={styles.listItemLeft}>Uppskattning av den genomsnittliga förbättringen: </Text>{productivity}%</Text>
          <Text style={styles.listItem}><Text style={styles.listItemLeft}>FÖRBÄTTRAT RESULTAT: </Text>{result} kronor</Text>
          <Text style={styles.link}>Nedladdad från <Link src="www.formgivaren.se">www.formgivaren.se</Link> som ägs av Proformia Hälsa AB.</Text>
        </View>
      </Page>
    </Document>
  );
}

// export default function PDFLink(props) {
//
//   return (
//     <PDFViewer style={{ width: '100%', height: '1000px'}}>
//       <PDFDocument {...props} />
//     </PDFViewer>
//   );
// }

export default function PDFLink(props) {
  return (
    <PDFDownloadLink document={<PDFDocument {...props} />} fileName="proformia - hälsokalkyl">
      {({ blob, url, loading, error }) => (loading ? 'Loading document...' : 'Ladda ned som PDF')}
      </PDFDownloadLink>
  );
}
